<script lang="ts">
	import type { DoubleColumnContent } from '../types';
	import Headline from './Headline.svelte';
	import Link from './Link.svelte';
	import RightCondensed from '@icons/RightCondensed.svelte';

	export let headline: string;
	export let content: string | DoubleColumnContent;
	export let imagePosition: 'left' | 'right';
	export let image: {
		src: string;
		alt: string;
	};

	export let ctaLinkText: string = '';
	export let ctaLinkUrl: string = '';
	export let loading: 'eager' | 'lazy' = 'eager';

	$: hasDoubleColumnContent = Array.isArray(content) && content.length > 1;
</script>

<!-- IDEA: limit max height for images that are very narrow and high, algin extra space to the outside then -->

<div
	class="relative content-module-padding bg-white rounded-3xl flex flex-col mt-24 lg:mt-33 items-center justify-between lg:items-start"
	class:lg:flex-row={imagePosition === 'left'}
	class:lg:pl-9={imagePosition === 'left'}
	class:lg:flex-row-reverse={imagePosition === 'right'}
	class:lg:pr-9={imagePosition === 'right'}
>
	<!-- used to optimize position of anchor scroll jump -->
	<div class="absolute -top-12 w-full opacity-0" {...$$restProps} />

	<div
		class="-mt-9 lg:mb-9 px-3 mdheader:px-4 lg:px-0 {hasDoubleColumnContent
			? 'lg:w-[35%] xl:w-[40%]'
			: 'lg:w-1/2'}"
	>
		<img
			src={image?.src}
			alt={image?.alt}
			class="w-full rounded-[20px]"
			class:lg:ml-auto={imagePosition === 'right'}
			{loading}
		/>
	</div>

	<div class="py-9 h-full my-auto {hasDoubleColumnContent ? 'lg:w-[65%] xl:w-[65%]' : 'lg:w-1/2'}">
		<div
			class="lg:pr-16"
			class:lg:pr-5={hasDoubleColumnContent}
			class:xl:pr-16={hasDoubleColumnContent}
			class:lg:pl-9={imagePosition === 'right'}
			class:lg:pl-16={imagePosition === 'left'}
			class:lg:pl-5={imagePosition === 'left' && hasDoubleColumnContent}
			class:xl:pl-16={imagePosition === 'left' && hasDoubleColumnContent}
		>
			<Headline
				size="secondary"
				responsive={false}
				tag="h2"
				class="px-3 mdheader:px-4 lg:px-0 mb-6 italic">{headline}</Headline
			>

			<div class="text-quaternary px-3 mdheader:px-4 lg:pl-9 lg:pr-0 wysisyg-content">
				<div class="flex flex-col md:flex-row gap-6">
					{#if typeof content === 'string'}
						<div>
							<!-- eslint-disable -->
							{@html content}
						</div>
					{:else if Array.isArray(content) && content.length > 0}
						{#each content as paragraph, i}
							<div class="flex-1">
								<!-- eslint-disable -->
								{@html content[i].content}
							</div>
						{/each}
					{/if}
				</div>

				{#if ctaLinkText && ctaLinkUrl}
					<Link tag="a" href={ctaLinkUrl} class="mt-3 lg:mt-6" rightIcon={RightCondensed}>
						{ctaLinkText}
					</Link>
				{/if}
			</div>
		</div>
	</div>
</div>
